import { HttpClient, HttpParams } from "@angular/common/http";
import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgxSpinnerService } from "ngx-spinner";
import { ProfileModel } from "src/app/models/Profile.model";
import Swal from "sweetalert2";

@Component({
  selector: "app-profile",
  templateUrl: "./profile.component.html",
  styleUrls: ["../../../assets/css/style.scss"],
})
/** Profile component*/
export class ProfileComponent implements OnInit {
  public Profile: ProfileModel[];
  public Nombres: any[] = [];
  public Estados: any[] = [];

  public NewProfile: ProfileModel = new ProfileModel();
  public UpdateProfile: ProfileModel = new ProfileModel();


  displayModal: boolean;
  displayModalEdit: boolean;

  FormAddProfile: FormGroup;
  submitted = false;

  /** Profile ctor */
  constructor(
    public http: HttpClient,
    private SpinnerService: NgxSpinnerService,
    private _builder: FormBuilder,
    private cdRef: ChangeDetectorRef
  ) {}


  get formAddProfile() {
    return this.FormAddProfile.controls;
  }

  ngOnInit(): void {
    this.GetAll();
    this.FormAddProfile = this._builder.group({
        Nombre: ['', [Validators.required, Validators.maxLength(50)]],
        Activo: ['', [Validators.required]]
      });
  }
  GetAll() {
    this.SpinnerService.show();
    let UserInf: any;
    UserInf = localStorage.getItem("ResponseData");
    let body = new HttpParams();
    body = body.set("data", UserInf);

    this.http
      .post<ProfileModel[]>(
        window.location.origin + "/api/Profile/GetPerfiles",
        body
      )
      .subscribe((data) => {
        this.Profile = data;
        console.log("-------PROFILES------");
        console.log(this.Profile);
        let nombre = {};
        this.Nombres = [];
        let stado = {};
        this.Estados = [];
        for (let index = 0; index < this.Profile.length; index++) {
          nombre = {
            label: this.Profile[index].Nombre,
            value: this.Profile[index].Nombre,
          };
          if (
            this.Nombres.find((x) => x.label === this.Profile[index].Nombre) ==
            null
          ) {
            this.Nombres.push(nombre);
            this.Nombres.sort((a, b) => {
              if (a.label < b.label) {
                return -1;
              }
              if (a.label > b.label) {
                return 1;
              }
              return 0;
            });
          }
          if (this.Profile[index].Activo === true) {
            stado = { label: "Active", value: this.Profile[index].Activo };
          } else {
            stado = { label: "Inactive", value: this.Profile[index].Activo };
          }
          if (
            this.Estados.find((x) => x.value === this.Profile[index].Activo) ==
            null
          ) {
            this.Estados.push(stado);
            this.Estados.sort((a, b) => {
              if (a.label < b.label) {
                return -1;
              }
              if (a.label > b.label) {
                return 1;
              }
              return 0;
            });
          }
        }
      });
    this.SpinnerService.hide();
  }

  hideModalDialog() {
    this.onReset();
    this.displayModal = false;
  }
  hideModalDialogEdit() {
    this.onReset();
    this.displayModalEdit = false;
  }
  showModalDialogAdd() {
    this.onReset();
    this.displayModal = true;
  }
  showModalDialogEdit() {
    this.onReset();
    this.displayModalEdit = true;
  }
  onReset() {
    this.submitted = false;
    this.FormAddProfile.reset();
  }

  public CreateProfile(data: ProfileModel) {
    data.IsDefault=false;
    debugger;
    var user = JSON.parse(localStorage.getItem("ResponseData"))
    data.CreadoPor = user.Email;
    data.FechaCreacion = new Date();
    //Spinner de Carga
    this.SpinnerService.show();

    //Seteando data de Auditoria
    data.Id = 0;

    // Construyendo body de la peticion
    var request = JSON.stringify(data);
    let body = new HttpParams();
    body = body.set('data', request);
    const bodyProfile = {
      ObjectRequest: request
    }

    if (this.FormAddProfile.invalid) {
      this.SpinnerService.hide();
      return;
    }
    if (this.NewProfile.Nombre == null ) {
      this.SpinnerService.hide();
      return;
    }
    this.http.post(window.location.origin + "/api/Profile/CreatePerfil", bodyProfile).subscribe((res) => {
      debugger;
      if (res == null) {
        this.hideModalDialog();
        this.SpinnerService.hide();
        this.cdRef.detectChanges();
        this.GetAll();
        Swal.fire({
          //position: 'top-end',
          icon: "error",
          title: "Failed to save Profile",
          showConfirmButton: false,
          timer: 1500,
        });
      } else{
        this.hideModalDialog();
        this.SpinnerService.hide();
        this.cdRef.detectChanges();
        this.GetAll();
        Swal.fire({
          //position: 'top-end',
          icon: "success",
          title: "Your work has been saved",
          showConfirmButton: false,
          timer: 1500,
        });
      }

    });
  }
  public GetIdProfile(data: ProfileModel) {
    this.UpdateProfile = new ProfileModel();
    this.SpinnerService.show();
    var request = JSON.stringify(data);
    let body = new HttpParams();
    body = body.set('ObjectRequest', request);
    const bodyProfile = {
      ObjectRequest: request
    }
    this.http.post<ProfileModel>(window.location.origin + '/api/Profile/GetIdPerfil', bodyProfile)
    .toPromise()
    .then(res => { // Success
        /* this.formProfile.get('Id').setValue(res.Id) */
        debugger;
        //Objeto para actualizar
        this.UpdateProfile = res;
        
        this.cdRef.detectChanges();
        //Servicio de Loader-Spinner
        this.SpinnerService.hide();
        //this.getAll();

      }
    ).catch(
      err => { // error
        console.error(err);
        this.SpinnerService.hide();

      }
    );

  }
  public UpdateProfiles(data: ProfileModel) {
    //Spinner de Carga
    this.SpinnerService.show();

    var user = JSON.parse(localStorage.getItem("ResponseData"))
    data.ModificadoPor = user.Email;
    data.FechaModificacion = new Date();
    // Construyendo body de la peticion
    var request = JSON.stringify(data);
    let body = new HttpParams();
    body = body.set('data', request);
    const bodyProfile = {
      ObjectRequest: request
    }

    /**** TODO: Validacion de Formulario antes de Enviar peticion  ****/

    this.http.post(window.location.origin + '/api/Profile/UpdatePerfil', bodyProfile).toPromise().then(
      res => { // Success

        this.hideModalDialogEdit();
        this.SpinnerService.hide(); 
        this.cdRef.detectChanges();  
        this.GetAll();     
        Swal.fire({
          //position: 'top-end',
          icon: 'success',
          title: 'Your work has been saved',
          showConfirmButton: false,
          timer: 1500
        })
      }
    ).catch(
      err => { // error
        console.error(err);
        this.SpinnerService.hide();
      }
    );

  }
  public DeleteProfiles(data: ProfileModel) {
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.value) {
        this.SpinnerService.show();
        var request = JSON.stringify(data);
        let body = new HttpParams();
        body = body.set('data', request);
        const bodyProfile = {
          ObjectRequest: request
        }
        this.http.post(window.location.origin + '/api/Profile/DeletePerfil', bodyProfile).toPromise().then(
          res => { // Success
            var respuesta: any;
            respuesta = res;
            console.log(res);
            if (respuesta.Head.StackError) {
              this.SpinnerService.hide();
              Swal.fire(
                'Error!',
                'Something went wrong!',
                'error'
              )
            } else {              
              this.ngOnInit();
              this.SpinnerService.hide();              
              Swal.fire(
                'Deleted!',
                'The Parameter has been deleted.',
                'success'
              )
            }
          }
        ).catch(
          err => { // error
            console.error(err);
            this.SpinnerService.hide();
          }
        );

      }
    })
  }
}
